module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (156).ef3dc85d.jpg";